import { CircularProgress, LinearProgress } from "@material-ui/core";
import React from "react";

const Loader = ({ loading, circular, children }) => {
  if (!loading) {
    return children;
  }
  return circular ? <CircularProgress /> : <LinearProgress />;
};

export default Loader;
